import React from 'react';
import moment from 'moment';
import Typography from '@mui/material/Typography';
import Card from 'components/Card';
import { number_format } from '../../../functions';

const CardExtrato = (props) => {
  function formatDate(date) {
    if (date === 'Invalid date') {
      return 'Não ocorreu';
    }
    return date;
  }

  const columnsStyle = {
    display: 'grid',
    gridTemplateColumns: 'minmax(280px, 5fr) minmax(280px, 5fr) minmax(140px, 2fr)',
    columnGap: 32,
    rowGap: 14,
    alignItems: 'start',
  };

  return (
    <Card style={{ marginBottom: '10px' }} bordered borderhexcolor={props.status_color}>
      <div style={columnsStyle}>
        <div>
          <Typography variant="caption" component="p" gutterBottom>
            <strong>Origem: </strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            {props.travel.origins[0].formatted}
          </Typography>
        </div>
        <div>
          <Typography variant="caption" component="p" gutterBottom>
            <strong>Destino: </strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            {props.travel.destinations[props.travel.destinations.length - 1].formatted}
          </Typography>
        </div>
        <div>
          <Typography variant="caption" component="p" gutterBottom>
            <strong>Valor</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            {`R$ ${number_format(props.travel.balance, 2, ',', '.')}`}
          </Typography>
        </div>
        <div>
          <Typography variant="caption" component="p" gutterBottom>
            <strong>Motorista: </strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            {props.travel.driver.social_name}
          </Typography>
        </div>
        <div>
          <Typography variant="caption" component="p" gutterBottom>
            <strong>Tomador: </strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            {props.travel.load.client.social_name}
          </Typography>
        </div>
        <div>
          <Typography variant="caption" component="p" gutterBottom>
            <strong>Ordem de coleta: </strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            {formatDate(moment(props.travel.created_at).format('DD/MM/YYYY HH:mm'))}
          </Typography>
        </div>
        <div>
          <Typography variant="caption" gutterBottom>
            <strong>Número da viagem: </strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            {props.travel.id}
          </Typography>
        </div>
        <div>
          <Typography variant="caption" gutterBottom>
            <strong>Número da carga</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            {props.travel.load_id}
          </Typography>
        </div>
      </div>
    </Card>
  );
};

export default CardExtrato;
